import React from 'react';
import Text from '@atlaskit/ds-explorations/text';
import { Box, xcss } from '@atlaskit/primitives';
var containerStyles = xcss({
  display: 'flex',
  position: 'relative'
});
export default function renderEllipsis(_ref) {
  var key = _ref.key,
    testId = _ref.testId;
  return /*#__PURE__*/React.createElement(Box, {
    as: "span",
    testId: testId,
    key: key,
    xcss: containerStyles,
    paddingInline: "space.100"
  }, /*#__PURE__*/React.createElement(Text, {
    testId: "".concat(testId, "-text"),
    verticalAlign: "middle"
  }, "\u2026"));
}